<template>
  <div class="header-space min-height">
    <div class="flex home-container pb-5">
      <div class="mt-4 ml-4 logo-container">
        <div class="text-align-center">
          <img
            id="profile-img"
            style="width: 50%; height: 50%"
            class="m-auto"
            src="@/assets/images/logo.png"
          />
          <p style="font-size: 3vh">
            <span class="bold-text logo-color">Con</span>necting
            <span class="bold-text logo-color">P</span>rofessional and
            <span class="bold-text logo-color">E</span>ducational
            <span class="bold-text logo-color">C</span>ommunities for future
            workforce development.
          </p>
          <div class="mt-3" style="font-size: 2vh">
            Are you a construction practitioner that wants to give back?<br />
            Do you want to contribute to future workforce development?<br />
            <router-link to="/register">
              Sign up</router-link
            >
            today to connect with instructors in construction-related academic 
            programs seeking construction practitioners to help them prepare
            students for the construction industry.
            <br /><br />

            Are you an instructor in a construction-related academic program with practical 
            course-support needs that construction practitioners can meet?<br />
            <router-link to="/register">Sign up</router-link> today 
            to get connected to a diverse pool of construction practitioners seeking to meet 
            your practical course-support needs.
          </div>
        </div>
      </div>
      <div class="form-container">
        <div class="card card-container">
          <Form
            @submit="handleLogin"
            :validation-schema="schema"
            v-slot="{ values }"
          >
            <div class="form-group">
              <label style="font-size:1.5vh" for="username">Email</label>
              <Field name="username" type="text" class="form-control" />
              <ErrorMessage name="username" class="error-feedback" />
            </div>
            <div style="font-size:1.5vh" class="form-group">
              <label for="password">Password</label>
              <Field
                name="password"
                v-model="values.password"
                v-slot="{ field }"
                class="form-control"
              >
                <Password
                  v-model="values.password"
                  v-bind="field"
                  toggleMask
                  :feedback="false"
                  class="w-100"
                />
              </Field>
              <ErrorMessage name="password" class="error-feedback" />
            </div>

            <div style="font-size:1.5vh" class="form-group mt-2">
              <Field
                value="True"
                unchecked-value="False"
                name="keepSignedIn"
                type="checkbox"
              />&nbsp;Keep Me Signed In <br />
            </div>

            <br />
            <div class="form-group text-align-center">
              <button class="btn btn-primary btn-login btn-block" :disabled="loading">
                <span
                  v-show="loading"
                  class="spinner-border spinner-border-sm"
                ></span>
                <span>Login</span>
              </button>
              <div class="mt-3" v-if="loginMessage">
                <div class="alert alert-danger" role="alert">
                  {{ loginMessage }}
                </div>
              </div>
              <div class="mt-1" style="color: #0d6efd">
                <router-link style="font-size:1.5vh" to="/forgotPassword" class="nav-link">
                  <span>Forgot Password?</span>
                </router-link>
              </div>
            </div>
          </Form>
          <div class="mt-2 text-align-center fs-1-5">
            New Here?
            <br />
            <button
              class="btn btn-primary btn-signup btn-block"
              style="margin: 10px 0px"
              :disabled="loading"
            >
              <router-link to="/register" class="nav-link">
                Sign Up
              </router-link>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="feedback-container" v-if="content.length > 0">
      <p class="text-align-center feedback-heading">
        What users are saying about us.
      </p>
      <div class="flex justify-content-between">
        <div
          class="flex flex-grow-0 flex-shrink-1 align-items-center"
          style="margin: auto"
        >
          <button type="button" class="feedback-btn btn" @click="moveToPrev">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 48 48"
              fill="none"
              stroke="#000"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="vertical-align-sub"
            >
              <polyline points="27,36 9,18 27,0"></polyline>
            </svg></button
          >&nbsp;
        </div>
        <div class="text-align-center feedback-text-container">
          <div class="row feedback-content">
            <p>{{ content[currentIndex].message }}</p>
          </div>
        </div>
        <div
          class="flex flex-grow-0 flex-shrink-1 align-items-center"
          style="margin: auto"
        >
          <button type="button" class="feedback-btn btn" @click="moveToNext">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 -10 48 48"
              fill="none"
              stroke="#000"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="vertical-align-super"
            >
              <polyline points="9,36 27,18 9,0"></polyline>
            </svg>
          </button>
        </div>
      </div>
      <div class="text-align-center">
        <p class="customer-name mt-3 mb-1">
          {{
            content[currentIndex].user.firstName +
            " " +
            content[currentIndex].user.lastName
          }}
        </p>
        <p>
          <span> {{ content[currentIndex].user.nameOrg }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import Password from "primevue/password";
import UserService from "@/services/user.service.js";
import { useAuthStore } from "@/stores/AuthStore";
import { useCourseStore } from "@/stores/CourseStore";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();
const AuthStore = useAuthStore();
const CourseStore = useCourseStore();

const schema = yup.object().shape({
  username: yup
    .string()
    .email("Please Enter a valid email address")
    .required("Email is required!"),
  password: yup.string().required("Password is required!"),
});

let loading = ref(false);
let message = ref("");
let loginMessage = ref("");
let coeff = 1000 * 60 * 5;

const handleLogin = (user) => {
  loading.value = true;
  AuthStore.login(user).then(
    (res) => {
      console.log(res);
      if (route.query["redirect"]) {
        handleRedirect(route.query["redirect"]);
      } else if (AuthStore.role === "INSTRUCTOR")
        if (AuthStore.profile) router.push({ name: "instructor-feed" });
        else router.push({ name: "instructor-profile" });
      else if (AuthStore.role === "INDUSTRYPRACTITIONER")
        if (AuthStore.profile)
          router.push({ name: "industry-practitioner-feed" });
        else router.push({ name: "industry-practitioner-profile" });
      else if (AuthStore.role === "ADMIN") router.push({ name: "admin-feed" });
      else router.push("/home");
    },
    (error) => {
      console.log(error);
      let activationTime = error.response?.data?.activationTime;
      if (activationTime) {
        if (new Date(activationTime) > new Date(2029, 0, 1, 0, 0, 0)) {
          loginMessage.value =
            "Your account has been deactivated by the admin.";
        } else {
          let date = new Date(activationTime);
          let rounded = new Date(Math.ceil(date.getTime() / coeff) * coeff);
          loginMessage.value =
            "Your account has been deactivated by the admin. Your account will become active by " +
            rounded.toLocaleDateString() +
            " at " +
            new Date().toLocaleTimeString();
        }
      } else {
        loginMessage.value =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
      loading.value = false;
    }
  );
};

let currentIndex = ref(0);
let content = ref([]);
let instructorOrgList = ref([]);
let practitionerOrgList = ref([]);

const getFeedback = () => {
  UserService.getFeedback().then(
    (response) => {
      content.value = response.data;
    },
    (error) => {
      message.value =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
    }
  );
};

const getOrgList = (roleType) => {
  UserService.getOrgList(roleType).then(
    (response) => {
      if (roleType == "1") instructorOrgList.value = response.data;
      else practitionerOrgList.value = response.data;
    },
    (error) => {
      message.value =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
    }
  );
};

const handleRedirect = async (redirectURL) => {
  const notificationId = redirectURL.split("/").pop();
  console.log(notificationId);
  UserService.getNotification(notificationId).then(
    (response) => {
      const notification = response.data;
      notification.course_request.user = notification.user;
      CourseStore.addCourse(notification.course_request);
      if (AuthStore.role === "INDUSTRYPRACTITIONER")
        router.push({ name: "view-course-request-prac" });
      else if (AuthStore.role === "INSTRUCTOR") {
        CourseStore.setPractitioner(notification.user.id);
        router.push({ name: "view-industry-practitioner-ins" });
      } else router.push("/home");
    },
    (error) => {
      loading.value = false;
      router.push("/home");
    }
  );
};

getFeedback();
getOrgList("1");
getOrgList("2");

const moveToNext = () => {
  currentIndex.value = (currentIndex.value + 1) % content.value.length;
};

const moveToPrev = () => {
  if (currentIndex.value === 0) currentIndex.value = content.value.length - 1;
  else currentIndex.value = (currentIndex.value - 1) % content.value.length;
};

setInterval(() => {
  moveToNext();
}, 5000);
</script>

<style scoped>
.card-container.card {
  max-width: 60% !important;
  padding: 40px 40px 20px 40px;
}

.btn-login {
  border-radius: 70px;
}

.btn-signup {
  font-size: 2.5vh;
  width: 100%;
  height: 5vh;
  border-radius: 70px;
}

.feedback-container {
  padding: 2rem 65px 1.5rem 65px;
  background: #fff;
  margin: 1em;
  color: #000;
}

.feedback-btn {
  margin: 0.25rem;
  padding: 0.25rem;
  border-radius: 10px;
}

.customer-name {
  font-family: lato;
  font-style: italic;
  font-weight: 900;
  font-size: 25px;
  line-height: 30px;
}

.feedback-heading {
  font-family: lato, sans-serif;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 42px;
  letter-spacing: 0;
  opacity: 1;
  transform: none;
}

.feedback-content {
  padding: 1rem 3rem 0rem 3rem;
}

.moving-text-container {
  overflow: hidden; /* To hide the text outside the container */
  font-size: 16px;
  font-weight: bold;
  color: #0d6efd;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  margin-top: 1rem;
}

.logo-color {
  color: #0d6efd;
}

.moving-text-lr {
  animation: moveLeftToRight 50s linear infinite; /* Adjust the duration and animation timing as needed */
  animation-delay: -5s;
}

.moving-text-rl {
  animation: moveRightToLeft 50s linear infinite; /* Adjust the duration and animation timing as needed */
  animation-delay: -5s;
}

@keyframes moveLeftToRight {
  from {
    transform: translateX(-100%); /* Move the text from left (off-screen) */
  }
  to {
    transform: translateX(100%); /* Move the text to the right (off-screen) */
  }
}

@keyframes moveRightToLeft {
  from {
    transform: translateX(100%); /* Move the text from right (off-screen) */
  }
  to {
    transform: translateX(-100%); /* Move the text to the left (off-screen) */
  }
}

.home-container {
  flex-direction: row;
  height: 100vh;
  background-image: url('classroom_picture(2).png');
  background-size: cover;
  background-repeat: no-repeat;
}

.logo-container {
  display: inline-block;
  width: 100%;
  height: 75vh;
  padding-bottom: 1vh;
  padding-left: 5vh;
  padding-right: 5vh;    
  background-color:rgba(255, 255, 255, 0.7);
  border-radius: 4px;
}

.form-container {
  width: 70%;
  padding-left: 28vh;
  padding-right: 18vh; 
}

.card-container {
  width: 100%; 
}

.card-container.card {
  max-width: 100% !important; /* Ensure no max-width restriction */
  padding: 40px 30px 20px 30px;     /* Adjust padding as needed */
}

.feedback-text-container {
  width: 50%;
  padding-left: 1rem;
  padding-right: 1rem;
}

.header-space ~ div {
  position: relative;
  top: 4em;
}

.fs-1-5 {
  font-size: 1.5rem;
}

@media only screen and (max-width: 600px) {
  
  .btn-login {
    border-radius: 70px;
    font-size: 2vh;
    height: 6vh;
    width: 12vh;
  }

  .btn-signup {
    font-size: 2vh;
    width: 100%;
    height: 6vh;
    border-radius: 70px;
  }

  .logo-container {
    display: none !important;
  }

  .home-container {
    flex-direction: column;
  }

  .card-container {
    padding-left: 5px;
    padding-right: 5px;
  }

  .card-container.card {
    max-width: 80% !important;
    padding: 10px 10px;
  }

  .form-container {
    width: 100%;
    padding-right: 10px;
    padding-left: 10px;
  }

  .feedback-container {
    padding: 0;
  }

  .feedback-text-container {
    width: 80%;
  }

  .feedback-content {
    padding: 0.5rem 0.25rem 0rem 0.25rem;
  }

  .fs-1-5 {
    font-size: 1rem;
  }
}
</style>
